import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService, CORE_APP_ROUTES, AppRoute } from '@web-client/shared';

@Injectable({
    providedIn: 'root'
})
export class BookmarkService {
    private readonly snackBar = inject(MatSnackBar);
    private readonly configService = inject(ConfigService);
    private readonly platformId = inject(PLATFORM_ID);

    bookmarkPage(title: string, description?: string) {
        if (!isPlatformBrowser(this.platformId)) return;

        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const shortcut = isMac ? '⌘ + D' : 'Ctrl + D';

        this.snackBar.open(`Press ${shortcut} to bookmark ${title}!`, 'Got it', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
        });

        if (navigator.share) {
            navigator.share({
                title: `${title} | ${this.configService.appName}`,
                text: description,
                url: window.location.href,
            }).catch((err) => { console.error('Share failed:', err); });
        }
    }

    downloadBookmarkPack() {
        if (!isPlatformBrowser(this.platformId)) return;

        const baseUrl = window.location.origin;
        const dt = Math.floor(new Date().getTime() / 1000);

        const generateSuiteHtml = (suite: AppRoute) => {
            const groupedChildren: Record<string, AppRoute[]> = {};
            suite.children?.forEach(child => {
                const cat = child.category || 'General';
                if (!groupedChildren[cat]) groupedChildren[cat] = [];
                groupedChildren[cat].push(child);
            });

            let childrenHtml = '';
            Object.entries(groupedChildren).forEach(([categoryName, tools]) => {
                childrenHtml += `            <DT><H3>${categoryName}</H3>\n            <DL><p>\n`;
                tools.forEach(tool => {
                    childrenHtml += `                <DT><A HREF="${baseUrl}${tool.path}">${tool.title}</A>\n`;
                });
                childrenHtml += `            </DL><p>\n`;
            });

            return `        <DT><H3 ADD_DATE="${dt}" LAST_MODIFIED="${dt}">${suite.title} Suite</H3>\n        <DL><p>\n${childrenHtml}        </DL><p>`;
        };

        const suitesHtml = CORE_APP_ROUTES.map(suite => generateSuiteHtml(suite)).join('\n');

        const bookmarkHtml = `<!DOCTYPE NETSCAPE-Bookmark-file-1>
<!-- This is an automatically generated file. -->
<META HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=UTF-8">
<TITLE>Bookmarks</TITLE>
<H1>Bookmarks</H1>
<DL><p>
    <DT><H3 ADD_DATE="${dt}" LAST_MODIFIED="${dt}" PERSONAL_TOOLBAR_FOLDER="true">${this.configService.appName}</H3>
    <DL><p>
        <DT><A HREF="${baseUrl}/" ADD_DATE="${dt}">Home</A>
        <DT><A HREF="${baseUrl}/blogs" ADD_DATE="${dt}">Blogs</A>
        <DT><A HREF="${baseUrl}/apps" ADD_DATE="${dt}">Apps</A>
${suitesHtml}
    </DL><p>
</DL><p>`;

        const blob = new Blob([bookmarkHtml], { type: 'text/html' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.configService.appName}-Bookmarks.html`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.snackBar.open('Bookmark pack downloaded! Import it via your Browser Settings.', 'Cool', {
            duration: 7000,
        });
    }
}
